import { defineComponent, h } from 'vue'
import FeatherIcon from 'vue-feather'
import feather from 'feather-icons'
import { camelCase, upperFirst } from 'lodash'

const iconsList = Object.keys(feather.icons)

const icons = {}

// Dynamically create components
iconsList.forEach((iconName) => {
  const iconNamePascalCase = upperFirst(camelCase(iconName))

  const defaultSize = '1rem'
  icons[`${iconNamePascalCase}Icon`] = defineComponent({
    name: `${iconNamePascalCase}Icon`,
    props: {
      size: { type: [String, Number], default: defaultSize }
    },
    emits: ['click'],
    render() {
      let size = this?.size || defaultSize
      if (size && typeof size === 'string' && size.match(/\dx/)) {
        let sizeAttr = size.replace(/x/g, '')
        size = `${sizeAttr}rem`
      }
      const $attrs = this.$attrs
      return h(FeatherIcon, {
        ...$attrs,
        type: iconName,
        size: size,
        onClick: this.$emit?.bind(this, 'click')
      })
    }
  })
})

export default icons
